import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deletePursuitContact } from "./api/apiPursuitContact";

export function useRemovePursuitContact(pursuitId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePursuitContact,
    onMutate: async (contactId) => {
      // Cancel any outgoing refetches
      // (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries(["pursuit", pursuitId]);

      // Snapshot the previous value
      const prevItem = queryClient.getQueryData(["pursuit", pursuitId]);

      queryClient.setQueryData(["pursuit", pursuitId], {
        ...prevItem,
        contacts: prevItem.contacts.filter(
          (contact) => contact.id !== contactId
        ),
      });
      // Return a context object with the snapshotted value
      return { prevItem };
    },
    // Always refetch after error or success:
    onError: (e, newItem, context) => {
      queryClient.setQueryData(["pursuit", pursuitId], context?.prevItem);
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries(["pursuit", pursuitId]);
    },
  });
}
